<template>
	<div class="container">
		<el-card>
			<div slot="header">水表管理</div>
			<div style="height: 100%">
				<div>
					<el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
					<el-button type="primary" size="small" @click="importExcelClick">批量导入</el-button>
					<el-button type="primary" @click="addMeter" icon="el-icon-plus" size="small"
						style="background-color: #1c84c6 !important">添加</el-button>
					<el-button type="primary" @click="editMeter" class="el-icon-edit" size="small"
						style="background-color: #1abc9c !important">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="deleteMeter"
						style="background-color: #ed5565 !important">删除</el-button>
					<el-button type="primary" class="iconfont icon-excel" size="small" @click="exportToExcel"
						style="background-color: #23c6c8 !important">导出</el-button>
				</div>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<el-form-item label="创建时间">
						<el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
						<label> 到 </label>
						<el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="水表编号">
						<el-input v-model="queryParams.meterAddr" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="水表型号">
						<el-input v-model="queryParams.model" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="水表厂商">
						<el-select v-model="queryParams.producer" placeholder="请选择" clearable filterable>
							<el-option v-for="item in producerOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否在线">
						<el-select v-model="queryParams.onFlag" placeholder="请选择" clearable>
							<el-option v-for="item in flagOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否使用">
						<el-select v-model="queryParams.useFlag" placeholder="请选择" clearable class="searchTag">
							<el-option v-for="item in flagOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table ref="waterSettingTable" :data="tableData" style="width: 100%" height="92%"
						v-loading="loading" id="waterMeterRecordTable" highlight-current-row
						@current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" align="center">
						</el-table-column>
						<el-table-column prop="meterAddr" label="水表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="水表型号" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="水表厂商" align="center">
						</el-table-column>
						<el-table-column prop="valveState" label="阀门状态" width="120" align="center">
						</el-table-column>
						<el-table-column prop="breakFlag" label="开合阀状态" width="120" align="center">
						</el-table-column>
						<el-table-column prop="onFlag" label="是否在线" width="100" align="center">
						</el-table-column>
						<el-table-column prop="useFlag" label="是否使用" width="100" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<!-- 编辑 -->
		<el-dialog :title="meterDialogTitle" :visible.sync="meterDialogVisible" width="800px">
			<el-form :model="meterForm" label-width="100px">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表编号">
							<el-input v-model="meterForm.meterAddr" :disabled="meterFormDisable"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="水表型号">
							<el-input v-model="meterForm.model"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="水表厂商">
							<el-select v-model="meterForm.producer" placeholder="请选择" clearable
								:disabled="meterFormDisable">
								<el-option v-for="item in producerOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="终端类型">
							<el-select v-model="meterForm.terminalId" placeholder="请选择" clearable
								:disabled="meterFormDisable">
								<el-option v-for="item in terminalOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="备注">
							<el-input v-model="meterForm.remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="meterDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 批量导入对话框 -->
		<el-dialog title="批量导入" :visible.sync="importExcelDialogVid" width="800px">
			<div>
				<el-upload class="upload" action="" :multiple="false" :show-file-list="false"
					accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					:http-request="importInExcel">
					<el-button size="small" type="primary">选取文件</el-button>
				</el-upload>

				<el-table :data="excelTableData" border style="width: 100%">
					<el-table-column prop="meterAddr" label="水表编号" align="center">
					</el-table-column>
					<el-table-column prop="model" label="水表型号" width="120" align="center">
					</el-table-column>
					<el-table-column prop="producer" label="水表厂商" width="120" align="center" v-if="false">
					</el-table-column>
					<el-table-column prop="producerName" label="水表厂商" width="120" align="center">
					</el-table-column>
					<el-table-column prop="terminalId" label="终端类型" width="120" align="center" v-if="false">
					</el-table-column>
					<el-table-column prop="terminalIdName" label="终端类型" width="120" align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" width="150" align="center">
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer">
				<el-button @click="importExcelDialogVid = false">取 消</el-button>
				<el-button type="primary" @click="batchAdd">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull,
		export_excel_file,
	} from '../../untils/func';
	import exportTable from '../../untils/exportTable';
	import {
		selectList,
		save,
		detail,
		remove,
		getPath,
		load,
		waterBatchAdd,
	} from '../../api/property/waterSetting';
	import {
		selectWaterProducerList,
		selectWaterTerminalList,
		selectDictionaryListByName,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				excelTableColumnName: [
					'水表编号',
					'水表型号',
					'水表厂商',
					'终端类型',
					'备注',
				],
				excelTableColumnProperty: [
					'meterAddr',
					'model',
					'producer',
					'terminalId',
					'remark',
				],
				excelTableNotEmptyColumn: [
					'水表编号',
					'水表型号',
					'水表厂商',
					'终端类型',
				],

				excelTableComboboxColumn: ['水表厂商', '终端类型'],
				excelTableComboboxColumnValues: [],

				excelTableData: [],
				flagOptions: [], //是否在线options
				form: {},
				meterForm: {},
				meterDialogVisible: false,
				importExcelDialogVid: false,
				importTableData: [],
				meterDialogTitle: '',
				// 字典表格数据
				tableData: [],
				producerOptions: [], //厂商类型options
				terminalOptions: [], //终端类型options
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
					id: '',
				},
				// 遮罩层
				loading: true,
				total: 0,
				currentRow: null,
				meterFormDisable: false,
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			// 点击模板按钮下载文件
			async downloadTemplate() {
				let res = await getPath({
					name: '水表模板'
				}).then();
				let filePath = res.data;
				if (!filePath) {
					this.$message.error('模板未上传');
				} else {
					res = await load({
						filePath: filePath
					}).then();
					export_excel_file(res.data, '水表模板', res.headers.fileextend);
					// this.msgSuccess('下载成功');
				}
			},

			async batchAdd() {
				await waterBatchAdd(this.excelTableData).then();
				this.importExcelDialogVid = false;
				await this.handleQuery();
				this.msgSuccess('导入成功');
			},

			importInExcel(e) {
				let file = e.file; // 文件信息

				if (!file) {
					// 没有文件
					return false;
				} else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
					// 格式根据自己需求定义
					this.$message.error('上传格式不正确，请上传xls或者xlsx格式');
					return false;
				}

				const fileReader = new FileReader();
				fileReader.onload = (ev) => {
					try {
						const data = ev.target.result;
						const workbook = XLSX.read(data, {
							type: 'binary', // 以字符编码的方式解析
						});
						const exlname = workbook.SheetNames[0]; // 取第一张表
						const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容

						var i = 0;
						var j = 0;

						//判断必填列
						for (i = 0; i < exl.length; i++) {
							for (let column of this.excelTableNotEmptyColumn) {
								if (exl[i][column] == undefined) {
									this.msgError('第' + (i + 1) + '行' + column + '列不能为空');
									return;
								}
							}
						}

						//判断下拉框列数据是否合法
						for (i = 0; i < exl.length; i++) {
							for (j = 0; j < this.excelTableComboboxColumn.length; j++) {
								var value = exl[i][this.excelTableComboboxColumn[j]];

								if (value != undefined) {
									var flag = false;
									for (let option of this.excelTableComboboxColumnValues[j]) {
										if (option.value == value) {
											flag = true;
											break;
										}
									}

									if (!flag) {
										this.msgError(
											'第' +
											(i + 1) +
											'行' +
											this.excelTableComboboxColumn[j] +
											'列值不合法'
										);
										return;
									}
								}
							}
						}

						//转换成table数据
						for (i = 0; i < exl.length; i++) {
							var rowO = {};
							for (j = 0; j < this.excelTableColumnProperty.length; j++) {
								flag = false;
								var k = 0;
								for (k = 0; k < this.excelTableComboboxColumn.length; k++) {
									if (
										this.excelTableColumnName[j] ==
										this.excelTableComboboxColumn[k]
									) {
										flag = true;
										break;
									}
								}

								if (flag) {
									for (var option of this.excelTableComboboxColumnValues[k]) {
										if (option.value == exl[i][this.excelTableColumnName[j]]) {
											rowO[this.excelTableColumnProperty[j]] = option.key;
											rowO[this.excelTableColumnProperty[j] + 'Name'] =
												option.value;
											break;
										}
									}
								} else {
									rowO[this.excelTableColumnProperty[j]] =
										exl[i][this.excelTableColumnName[j]];
								}
							}
							this.excelTableData.push(rowO);
						}
					} catch (e) {
						console.log('出错了：：' + e);
						return false;
					}
				};
				fileReader.readAsBinaryString(file);
			},
			async init() {
				await this.handleQuery();
				// 下拉列表数据
				await this.getProducer();
				await this.getFlag();
				await this.getSelectWaterTerminalList();
				this.excelTableComboboxColumnValues.push(this.producerOptions);
				this.excelTableComboboxColumnValues.push(this.terminalOptions);
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				// console.log(this.tableData);
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			cancelChoose() {
				this.$refs.waterSettingTable.setCurrentRow();
				this.currentRow = null;
			},
			// 获取下拉列表 数据
			async getProducer() {
				// 水表厂商类型
				const res2 = await selectWaterProducerList().then();
				this.producerOptions = res2.data;
			},
			// 是否在线
			async getFlag() {
				// 电表制式
				const res = await selectDictionaryListByName(
					dictionaryConstant.YES_OR_NO
				).then();
				this.flagOptions = res.data;
			},
			async getSelectWaterTerminalList() {
				// 水表终端类型
				const res = await selectWaterTerminalList().then();
				this.terminalOptions = res.data;
			},
			async addMeter() {
				// 添加水表
				this.meterForm = {};
				this.meterDialogTitle = '添加水表';
				this.meterDialogVisible = true;
				this.meterFormDisable = false;
			},
			async save() {
				await save(this.meterForm).then();
				await this.handleQuery();
				this.msgSuccess('保存成功');
				this.meterDialogVisible = false;
			},
			async editMeter() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await this.viewDetail();
					this.meterDialogTitle = '编辑水表';
					this.meterDialogVisible = true;
					// this.meterFormDisable = true;

				}
			},
			async deleteMeter() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await this.$confirm('确定要删除吗?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(async () => {
						await remove(this.currentRow).then();
						await this.handleQuery();
						this.msgSuccess('删除成功');
					});
				}
			},
			async viewDetail() {
				const res = await detail({
					id: this.currentRow
				}).then();
				this.meterForm = res.data;
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				this.currentRow = val.id;
			},
			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('waterMeterRecordTable', '水表参数表');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			// 打开批量导入对话框
			importExcelClick() {
				this.excelTableData = [];
				this.importExcelDialogVid = true;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-select {
		width: 100%;
	}

	/deep/ .el-input {
		width: 100%;
	}

	.searchTag {
		width: 200px;
	}

	.searchForm {
		margin-top: 15px;

		.el-form-item {
			margin-bottom: 10px !important;
			display: inline-block;
		}
	}

	.tableStyle {
		height: calc(100% - 125px);
		// background-color: pink;
	}

	@media screen and (max-width: 1385px) {
		.tableStyle {
			height: calc(100% - 160px);
		}
	}
	.block{
		margin-top: 10px;
	}
</style>
